"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.A = void 0;
var styled_components_1 = require("styled-components");
var Theme_1 = require("../Theme");
exports.A = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    /* !important required as SRW overrides <a> */\n    color:  ", ";\n    text-decoration: underline;\n    font-size: inherit;\n    font-family: ", "\n"], ["\n    /* !important required as SRW overrides <a> */\n    color:  ", ";\n    text-decoration: underline;\n    font-size: inherit;\n    font-family: ", "\n"])), Theme_1.important(Theme_1.Color.Blue.B60), Theme_1.FontFamily);
var templateObject_1;
